import axios from 'axios';

axios.defaults.baseURL=process.env.VUE_APP_SERVER_URL;
axios.defaults.headers.get["Content-Type"]='application/x-www-form-urlencoded';
axios.defaults.headers.get["Authorization"]=sessionStorage.getItem("token");
axios.defaults.headers.get["X-Requested-With"]='XmlHttpRequest';
axios.defaults.withCredentials=false;